import DailyActivityGraph from './DailyActivityGraph'
export default DailyActivityGraph
